import { Breadcrumb, Button, DataTable, Dropdown, Filter, Search } from "pepsico-ds";
import React, { use, useEffect, useRef, useState } from "react";
import CustomTooltipCellRenderer from "../../common/custom_grid_tooltip";
import CustomCellRender from "../workflow/customCellRender";
import AgGridComponent from "../../common/ag_grid";
import ActionCellRender from "../workflow/actionCellRender";
import { useLocation, useNavigate } from "react-router-dom";
import arReactivateService from "../../services/arReactivateService";
import axios from "axios";
import { useLoading } from "../../loader.jsx";
import { useTranslation } from "react-i18next";
import { toast,ToastContainer } from 'react-toastify';
import NoDataFound from "../../common/no_data_found.jsx";

const OtherUsersProfileSearch = () => {
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [toasts, setToasts] = useState([]);
  const { t } = useTranslation();
  const [filteredItems, setFilteredItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const { state } = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [itemsPerPage] = useState(10);
  const [searchByType, setSearchByType] = useState({ id: "gpid", label: t('nonArExtension.gpid') });
  const [searchByValue, setSearchByValue] = useState('');
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoading();
  const [selectedUser, setSelectedUser] = useState(null);
  const agGridRef = useRef(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchType, setSearchType] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const selectedGPID = useRef('');
  const [columns, setColumns] = useState([
    { columnKey: "gpid", header: "GPID", initialSize: 130 , cellData: (ctx) => {
        return <>
            <input
                type="radio"
                name="row-selection"
                value={ctx.row.original.gpid}
                checked={!!(selectedGPID.current && selectedGPID.current === ctx.row.original.gpid)}
                onChange={(e) => onRowSelectionChange(e, ctx.row.original)}
                style={{ textAlign: 'center', marginRight: '10px' }}
            />
                {ctx.row.original.gpid}
            </>
    }},
    { columnKey: "firstName", header: "FIRST NAME", initialSize: 130, showColumnVisibility: true },
    { columnKey: "lastName", header: "LAST NAME", initialSize: 130, sortable: true },
    { columnKey: "email", header: "Email", size:200 },
    { columnKey: "associateType", header: "ASSOCIATE TYPE", initialSize: 170 },
    { columnKey: "division", header: "DIVISION", initialSize: 120 },
    { columnKey: "subDivision", header: "SUBDIVISION", initialSize: 120 },
    { columnKey: "location", header: "LOCATION", initialSize: 120, cellClass: "wrap-cell" },
    { columnKey: "status", header: "STATUS", initialSize: 120 },
    { columnKey: "registered", header: "REGISTERED", initialSize: 120 },
  ]);

  useEffect(() => {
    if (state.from !== 'update-profile') {
      getUsersData();
    }
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // const [columnDefs] = useState([
  //   {
  //     headerName: "Actions",
  //     cellRenderer: ActionCellRender,
  //     cellRendererParams: {
  //       onSelectUser: (data) => {
  //         if(state.from === 'update-profile'){
  //         navigate(`/update-profile`, { state: {from: state.from, reportingMangerData: data, searchType: state.searchType, userProfileBy: state.userProfileBy || null, associateType: state.associateType || null, gpId: state.gpId || null } });

  //         }
  //         else {
  //           showSelectButton(data);
  //         }
  //       },
  //       buttons: [
  //         { text: "Select", variant: "primary", action: "select" }
  //       ],
  //     },
  //     field: "actions",
  //     width: 250
  //   },
  //   { headerName: "GPID", field: "gpid" },
  //   { headerName: "First Name", field: "firstName" },
  //   { headerName: "Last Name", field: "lastName" },
  //   { headerName: "Email", field: "email" },
  //   { headerName: "Associate Type", field: "associateType" },
  //   { headerName: "Division", field: "division" },
  //   { headerName: "Sub Division", field: "subDivision" },
  //   { headerName: "Location", field: "location" },
  //   { headerName: "Status", field: "status" },
  //   { headerName: "Registered", field: "registered" },
  // ]);

  const onRowSelectionChange = (e, user) => {
      e.stopPropagation();
      // if(state.from === 'update-profile'){
      //   navigate(`/update-profile`, { state: {from: state.from, reportingMangerData: user, searchType: state.searchType, userProfileBy: state.userProfileBy || null, associateType: state.associateType || null, gpId: state.gpId || null } });
      // }
      // else {
        showSelectButton(user);
      // }
      selectedGPID.current = user.gpid;
  };

  const showSelectButton = (data) => {
    // setFilteredItems(prevItems => prevItems.map(item => 
    //   item.gpid === data.gpid ? { ...item, isSelected: true } : { ...item, isSelected: false }
    // ));
    setSelectedUser(data);  
    agGridRef.current?.refreshActionsColumn();
  }

  const onUserSelect = () => {
    const data = selectedUser;
    if(state.from === 'update-profile'){
      navigate(`/update-profile`, { state: {from: state.from, [state.searchType]: data.gpid , reportingMangerData: data, searchType: state.searchType, userProfileBy: state.userProfileBy || null, associateType: state.associateType || null, gpId: state.gpId || null } });
    }
    else {
      navigate(`/update-profile`, { state: { gpId: data.gpid, associateType: data.associateType, userProfileBy: 'Others' } });
    }
  }

  const onClickCancel = () => {
    if(state.from === 'update-profile') navigate(`/update-profile`, { state: {from: state.from} });
    else navigate(-1)
  }

  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };
  
  // const getUsersData = async () => {
  //   setLoading(true);
  //   showLoader();
  //   setError(null);
  //   if (!state) {
  //     setError("Value is not found");
  //     return;
  //   }
  //   try {
  //     const filterMapping = {
  //       "first_name": "firstName",
  //       "last_name": "lastName",
  //       "email": "emailAddress",
  //       gpid: "gpid"
  //     }
  //     const KeyMapping = {
  //       "first_name": "First Name",
  //       "last_name": "Last Name",
  //       "email": "Email Address",
  //       gpid: "GPID"
  //     }
  //     let key = filterMapping[state.searchByType];
  //     let userId = key ? { [key]: state[state.searchByType] } : {};
  //     setSearchType(KeyMapping[state.searchByType] || "");
  //     setSearchValue(userId[key])
  //     const response = await arReactivateService.getReactivatedUser(userId);
  //     const allRows = Object.entries(response.data.mapOfRevalidationReactivateResponse).map(([gpid, user]) => ({
  //       gpid: gpid.trim(),
  //     }));
  //     setTotalRecords(allRows.length);
  //     // setRowData(allRows);
  //     const transformedData = Object.entries(response.data.mapOfRevalidationReactivateResponse).map(([gpid, user]) => ({
  //       gpid: gpid.trim(),
  //       firstName: user.pepDisplayedFirstName?.trim() || "",
  //       lastName: user.pepDisplayedLastName?.trim() || "",
  //       email: user.mail || "",
  //       associate_type: user.pepUserType || "",
  //       division: user.pepDivisionName || "",
  //       sub_division: user.pepsubdivision || "",
  //       location: user.hrCountryName || "",
  //       status: user.pepUserStatus || "",
  //       registered: user.pepRegistered || "",
  //       fromType: 'user_profile_search'
  //     }));
  //     setFilteredItems(transformedData);
  //   } catch (err) {
  //     setError(err.message || "API call failed");
  //   } finally {
  //     setLoading(false);
  //     hideLoader();
  //   }
  // }

   const getUsersData = async () => {
    setLoading(true);
    showLoader();
    if (state?.searchByType === 'gpid') {
      setSearchType("GPID");
      setSearchValue(state.gpid)
      axios.post(REACT_APP_API_ENDPOINT + "user/searchuser", {
        gpid: state.gpid
      }).then((response) => {
        setLoading(false);
        hideLoader();
        const allRows = Object.entries(response.data.userData).map(([gpid, user]) => ({
          gpid: gpid.trim(),
        }));
        // setRowData(allRows);
        const transformedData = Object.entries(response.data.userData).map(([gpid, user]) => ({
          gpid: gpid.trim(),
          firstName: user.pepDisplayedFirstName?.trim() || "",
          lastName: user.pepDisplayedLastName?.trim() || "",
          email: user.mail || "",
          associateType: user.pepUserType || "",
          division: user.pepDivisionName || "",
          subDivision: user.pepsubdivision || "",
          location: user.pepLocName || "",
          status: user.pepUserStatus || "",
          registered: user.pepRegistered || "",
        }));
        setFilteredItems(transformedData);
        setTotalRecords(transformedData.length);
        // setUsers(Object.values(response?.data?.userData));
      }).catch((error) => {
        setLoading(false);
        hideLoader();
        console.log('error', error);
      })
    }
    else {
      setError(null);
      if (!state) {
        setError("Value is not found");
        setLoading(false);
        hideLoader();
        return;
      }
      try {

        // let payload = { [searchByType?.id]: searchByValue };
        const filterMapping = {
          "first_name": "firstName",
          "last_name": "lastName",
          "email": "email",
          gpid: "gpid"
        }
        const KeyMapping = {
          "first_name": "First Name",
          "last_name": "Last Name",
          "email": "Email Address",
          gpid: "GPID"
        }
        let key = filterMapping[state.searchByType];
        let userId = key ? { [key]: state[state.searchByType] } : {};
        setSearchType(KeyMapping[state.searchByType] || "");
        setSearchValue(userId[key])
        axios.post(REACT_APP_API_ENDPOINT + "user/searchuser", userId).then((response) => {
          setLoading(false);
          hideLoader();
          const allRows = Object.entries(response.data.userData).map(([gpid, user]) => ({
            gpid: gpid.trim(),
          }));
          // setRowData(allRows);
          const transformedData = Object.entries(response.data.userData).map(([gpid, user]) => ({
            gpid: gpid.trim(),
            firstName: user.pepDisplayedFirstName?.trim() || "",
            lastName: user.pepDisplayedLastName?.trim() || "",
            email: user.mail || "",
            associateType: user.pepUserType || "",
            division: user.pepDivisionName || "",
            subDivision: user.pepsubdivision || "",
            location: user.pepLocName || "",
            status: user.pepUserStatus || "",
            registered: user.pepRegistered || "",
          }));
          setFilteredItems(transformedData);
          setTotalRecords(transformedData.length);
          // setUsers(Object.values(response?.data?.userData));
        }).catch((error) => {
          setLoading(false);
          hideLoader();
          console.log('error', error);
        })
      } catch (err) {
        setLoading(false);
        hideLoader();
        setError(err.message || "API call failed");
      } finally {
        setLoading(false);
        hideLoader();
      }
    }
  }

  const handleDropdownChange = (type, value) => {
    if(type!=="Equals"){
      setSearchByType(value);
      setSearchByValue("");
      setFilteredItems([]);
      setTotalRecords(0);
    }
  }

  const handleSearch = (value) => {
    let filteredValue = value;
      switch (searchByType?.id) {
          case "gpid":
              filteredValue = value.replace(/[^0-9]/g, "");
              break;

          case "firstName":
          case "lastName":
              filteredValue = value.replace(/[^A-Za-z\s]/g, "");
              break;

          // case "emailAddress":
          //     filteredValue = value.replace(/[^A-Za-z0-9@._-]/g, "");
          //     break;

          default:
              break;
      };
    setSearchByValue(filteredValue);
  }

  const searchUsers = async () => {
    setLoading(true);
    showLoader();
    // if (searchByType?.label === t('nonArExtension.gpid')) {
      axios.post(REACT_APP_API_ENDPOINT + "user/searchuser", {
        [searchByType?.id]: searchByValue,
        isEmployee: state.searchType==="reportingManager"
      }).then((response) => {
        setLoading(false);
        hideLoader();
        const allRows = Object.entries(response.data.userData).map(([gpid, user]) => ({
          gpid: gpid.trim(),
        }));
        // setRowData(allRows);
        const transformedData = Object.entries(response.data.userData).map(([gpid, user]) => ({
          gpid: gpid.trim(),
          firstName: user.pepDisplayedFirstName?.trim() || "",
          lastName: user.pepDisplayedLastName?.trim() || "",
          email: user.mail || "",
          associateType: user.pepUserType || "",
          division: user.pepDivisionName || "",
          subDivision: user.pepsubdivision || "",
          location: user.pepLocName || "",
          status: user.pepUserStatus || "",
          registered: user.pepRegistered || "",
        }));
        setFilteredItems(transformedData);
        setTotalRecords(transformedData.length);
        // setUsers(Object.values(response?.data?.userData));
      }).catch((error) => {
        setLoading(false);
        hideLoader();
        console.log('error', error);
      })
    // }
    // else {
    //   setError(null);
    //   if (!state) {
    //     setError("Value is not found");
    //     setLoading(false);
    //     hideLoader();
    //     return;
    //   }
    //   try {

    //     let payload = { [searchByType?.id]: searchByValue };
    //     const response = await arReactivateService.getReactivatedUser(payload);
    //     if(response?.data?.status === 'Failed'){
    //       setFilteredItems([]);
    //       setError(response?.data?.errorMessage || "Something went wrong. Please try again later.");
    //       toast.error(response?.data?.errorMessage || "Something went wrong. Please try again later.");
    //       setLoading(false);
    //       hideLoader();
    //       return;
    //     }
    //     const allRows = Object.entries(response.data.mapOfRevalidationReactivateResponse).map(([gpid, user]) => ({
    //       gpid: gpid.trim(),
    //     }));
    //     // setRowData(allRows);
    //     const transformedData = Object.entries(response.data.mapOfRevalidationReactivateResponse).map(([gpid, user]) => ({
    //       gpid: gpid.trim(),
    //       firstName: user.pepDisplayedFirstName?.trim() || "",
    //       lastName: user.pepDisplayedLastName?.trim() || "",
    //       email: user.mail || "",
    //       associate_type: user.pepUserType || "",
    //       division: user.pepDivisionName || "",
    //       sub_division: user.pepsubdivision || "",
    //       location: user.hrCountryName || "",
    //       status: user.pepUserStatus || "",
    //       registered: user.pepRegistered || "",
    //     }));
    //     setFilteredItems(transformedData);
    //     setTotalRecords(transformedData.length);
    //   } catch (err) {
    //     setLoading(false);
    //     hideLoader();
    //     setError(err.message || "API call failed");
    //   } finally {
    //     setLoading(false);
    //     hideLoader();
    //   }
    // }
  }

  const renderDataTable = () => {
    return (
        <>
          {
            loading ? 
            <div style={{minHeight: "35vh"}}></div> 
            : 
            // filteredItems.length ?
              <DataTable
                  className="datatable single-extension-table other-request-list other-users-profile-search-table"
                  columns={columns}
                  data={filteredItems}
                  enableSorting={true}
                  stickyHeader={true}
                  // style={{ maxHeight: isMobile ? '300px' : `calc(100vh - 356px)` }}
                  pageIndex={0}
                  pageSize={10}
                  searchPlaceholder="Type a search keyword"
                  selection="single"
                  showColumnFilters={false}              
                  showDescription={false}              
                  showSearchOption={false}
                  showTableHeader={false}
                  showTitle={false}
                  showPagination={true}
                  size="large"
                  tableDescription=""
                  tableHeader=""
                  noDataTitleText={`${state.from === 'update-profile' ? "Use the search above to view results" : ""}`}
                  noDataDescriptionText="No data to display "
              />
              // :
              // <NoDataFound hideSubLabel/>
           }
        </>
    )
  }


  return (
    <div id="other_users_profile_search" style={{marginLeft:"16px"}}>
      <Breadcrumb
        homeIcon={{
          icon: "home",
          onClick:()=>{
            navigate("/home")
          }
        }}
        breadcrumbs={[
            {
                label: t('menu.home')
            },
            {
                label: <div onClick={()=>{
                    navigate("/myidmPortal")
                  }}>{t("nonArExtension.myidm")}</div>
            },
            {
                label: t("myIdmPortal.manage_other_accounts")
            }
        ]}
        className=""
        // style={{marginBottom:"10px"}}
      />
       <div className="header-text-1 mb-2">Update Profiles for Others</div>
       <div className="bulk-save-container row justify-content-end align-items-center" style={{ marginTop: '20px' }}>
          <div className="extension-edit-actions col-md-6 col-12">
              <button className="extension-cancel-button ml-0" onClick={onClickCancel} >                
                  {t('RequestGPIDForNonEmployee.cancel_btn_label')}
              </button>
              <Button
                  className="ml-3"
                  size="medium"
                  text={t('RequestGPIDForNonEmployee.select_btn_label')}
                  variant="primary"
                  disabled={!selectedUser}
                  onClick={onUserSelect}
              />
          </div>
      </div>
      <div className='card p-4 handle-sticky-padding-profiles-table' style={{ marginTop: "-80px"}}>
        <div className="container-fluid">
          <div className="row align-items-center search-container">
            {/* <div className="col-12 col-lg-2 header_ar-title">
              <h6 className="mb-0">Search for a user</h6>
            </div> */}
            <div className="search-result">{filteredItems.length? `${totalRecords} ${t('RequestNewAccessForOthers.search')} ${t('RequestNewAccessForOthers.results_for')} ${searchType === "requestNumber" ? "Request Number" : searchType} “${searchValue ? searchValue : (filteredItems.length && searchByValue) ? searchByValue : ""}”` : ""}</div>
            {state.from === 'update-profile' && (
              // <div className="col-12 col-lg-10">
              //   <div className="d-flex flex-wrap justify-content-end align-items-center" style={{ gap: '12px' }}>

              //     <div className="d-flex flex-wrap justify-content-start" style={{ gap: '12px', minWidth: '320px' }}>
              //       <div style={{ flex: '1 1 150px', minWidth: '150px' }}>
              //         <Dropdown
              //           childList={[
              //             { displayText: "Global Personnel ID", id: "gpid" },
              //             { displayText: "First Name", id: "firstName" },
              //             { displayText: "Last Name", id: "lastName" },
              //             { displayText: "Email", id: "emailAddress" },
              //           ]}
              //           label=""
              //           placeholder="Search By"
              //           isClearable
              //           isRequired
              //           selection="single"
              //           size="medium"
              //           // selectedValue=[{displayText: "Global Personnel ID", id: "gpid"}
              //           setSelectedValue={(value) => handleDropdownChange("Search By", value)}
              //           onKeyDown={(e) => e.preventDefault()}
              //         />
              //       </div>
              //       {/* <div style={{ flex: '1 1 150px', minWidth: '150px' }}>
              //         <Dropdown
              //           childList={[
              //             { displayText: "Equals", id: "1" },
              //             { displayText: "Starts With", id: "2" },
              //           ]?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
              //           label=""
              //           placeholder="Equals"
              //           isClearable
              //           isRequired
              //           selection="single"
              //           size="medium"
              //           setSelectedValue={(value) => handleDropdownChange("Equals", value)}
              //           onKeyDown={(e) => e.preventDefault()}
              //         />
              //       </div> */}
              //     </div>

              //     <div className="d-flex flex-wrap justify-content-start" style={{ gap: '12px', minWidth: '320px' }}>
              //       <div style={{ flex: '1 1 220px', minWidth: '200px' }}>
              //         <Search
              //           className=""
              //           isAutoComplete={false}
              //           autoComplete="off"
              //           isClearable
              //           menuPosition="bottom-right"
              //           placeholderText="Type a search keyword"
              //           onSearch={(value) => handleSearch(value)}
              //           onUpdate={(value) => handleSearch(value)}
              //           onClear={() => handleSearch("")}
              //         />
              //       </div>
              //       <div style={{ flex: '0 0 auto' }}>
              //         <Button
              //           size="small"
              //           text="Search"
              //           variant="primary"
              //           iconTrailing=""
              //           disabled={!searchByType || !searchByValue}
              //           onClick={() => searchUsers()}
              //         />
              //       </div>
              //     </div>

              //   </div>
              // </div>
              <div className="search-bar">
                <Filter
                    isClearable={false}
                    // label={t('nonArExtension.select_criteria')}
                    menuPosition="bottom-right"
                    onChange={(value) => {
                        handleDropdownChange("Search By", value)
                    }}
                    options={[
                        { id: "gpid", label: t('nonArExtension.gpid') },
                        { id: "firstName", label: t('nonArExtension.first_name') },
                        { id: "lastName", label: t('nonArExtension.last_name') },
                        { id: "emailAddress", label: t('nonArExtension.email') },
                    ]}
                    selection="single"
                    size={`${isMobile ? "small" : "medium"}`}
                    showSearch={false}
                    style={{ marginBottom: `${isMobile ? "16px" : "unset"}` }}
                    value={searchByType}
                />
                <div>
                    <Search
                        value={searchByValue}
                        isClearable={false}
                        menuPosition="bottom-right"
                        onClear={function oFe() { }}
                        onSearch={() => searchUsers()}
                        onSelectOption={function oFe() { }}
                        onUpdate={(value) => handleSearch(value)}
                        // disabled={!selectedFilter}
                        placeholderText={t('nonArExtension.search_placeholder')}
                        size="medium"
                        delay={0}
                    />
                    {(searchByType && searchByType.label == t('nonArExtension.gpid')) && (
                        <div style={{ fontSize: "12px", color: "#808080" }}>{t('nonArExtension.info_message')}</div>
                    )}
                    {/* {warningMsg && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "12px" }}>
                            {warningMsg}
                        </div>
                    )} */}
                </div>
              </div>
            )}
          </div>
        </div>
        {renderDataTable()}
        {/* <div className="table-container" style={{height: 'calc(100vh - 308px)'}}>
          <AgGridComponent
            ref={agGridRef}
            columnDefs={columnDefs}
            gridHeight={'calc(100vh - 356px)'}
            rowData={filteredItems}
            rowSelection="single"
            pagination={true}
            paginationPageSize={itemsPerPage}
            currentPage={currentPage}
            sendSelectedRows={() => { }}
          />
        </div> */}
         {/* <div className="d-flex justify-content-end align-items-center mt-4">
            <button className="extension-cancel-button ml-0" onClick={onClickCancel} >                
                {t('RequestGPIDForNonEmployee.cancel_btn_label')}
            </button>
            <Button
                className="ml-3"
                size="medium"
                text={t('RequestGPIDForNonEmployee.select_btn_label')}
                variant="primary"
                disabled={!selectedUser}
                onClick={onUserSelect}
            />
        </div> */}
      </div>
      <ToastContainer
        position="bottom-center"
        data={toasts}
        removeToast={removeToast}
      />
    </div>
  );
};

export default OtherUsersProfileSearch;